import React, { useState, useEffect, useRef } from "react";
import { Button, Pagination, SelectPicker } from "rsuite";
import "./skuManagement.scss";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@rsuite/icons/FileDownload";

const SkuSubstitutionTable = (props: any) => {
	// const handleRowClick = (vendorRow: any) => {
	//   props.updateVendor(vendorRow);
	// }

	const csvHeaders = [
		{ label: "Product Group Description", key: "substitueGroup" },
		{ label: "Item Id", key: "GBID" },
		{ label: "Part Number", key: "MANUFACTURER_PART_NO_MFRPN" },
		{ label: "Master Vendor name", key: "master_vendor_name" },
		{ label: "Quantity", key: "volume" },
		{ label: "Net Cost($/Unit)", key: "cost" },
		{ label: "Sell Price($/Unit)", key: "Price" },
		{ label: "Gross Margin($)", key: "Margin" },
		{ label: "Action", key: "recommendation" },
		{ label: "Substitute", key: "SubstituteToItem" },
		{ label: "Opportunity", key: "adjMarginOpportunity" },
	];
	const exportFullRef = useRef<any>(null);
	const [csvData, setcsvData] = useState();
	const [selectedSubstitueGroup, setSelectedSubstitueGroup] =
		useState<any>(null);

	const actionOptions = ["Do Nothing", "Substitute", "Move to Non Stock"].map(
		(item) => ({ label: item, value: item })
	);

	const removeLeadingZero = (n: any) => {
		let newStr = n?.replace(/^0+/, "");
		return newStr;
	};

	const numberWithCommas = (x: any) => {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};

	const getSubstituteOptions = (materials: any) => {
		let options: any = [];
		materials.map((item: any, key: any) => {
			if (item.recommendation === "Do Nothing") {
				options = [...options, removeLeadingZero(item.GBID)];
			}
		});
		const SubstituteOptions = options.map((item: any) => ({
			label: item,
			value: item,
		}));
		return SubstituteOptions;
	};

	const exportExcel = () => {
		props.GetExportData();
	};

	useEffect(() => {
		if (props.SKUExportData?.length !== 0 && props.ExportFlag) {
			exportFullRef?.current?.link.click();
			props?.updateExportFlag(false);
		}
	}, [props.SKUExportData]);

	console.log(props.data, "props.data");

	return (
		<>
			<table className="common-table-ui shadow-md overflow-y-auto w-full">
				<thead>
					<tr>
						<th className="w-1/12">#</th>
						<th
							className={
								selectedSubstitueGroup ? "w-1/5" : "w-[100%]"
							}
						>
							Description
						</th>
						<th className="w-1/12">SKU#</th>
						{selectedSubstitueGroup && (
							<>
								<th className="w-1/12">Item Id</th>
								<th className="w-1/12">Part Number</th>
								<th className="w-1/12">Master Vendor name</th>
								<th className="w-1/12">Vol</th>
							</>
						)}
						<th className="w-1/12">Cost</th>
						{selectedSubstitueGroup && (
							<>
								<th className="w-1/12">Price</th>
								<th className="w-1/12">Margin</th>
								<th className="w-1/12">Action</th>
								<th className="w-1/12">Substitute</th>
							</>
						)}
						<th className="w-1/12">Opportunity</th>
						<th className="w-1/12"></th>
					</tr>
				</thead>
				<tbody>
					{props.data?.map((d: any, index: any) => {
						return (
							<React.Fragment key={d.substitueGroup + index}>
								<tr>
									<td>{index + 1}</td>
									<td style={{ textAlign: "start" }}>
										<div>
											{selectedSubstitueGroup ===
											d.substitueGroup ? (
												<MinusRoundIcon
													className="plusIcon"
													onClick={() => {
														setSelectedSubstitueGroup(
															null
														);
													}}
												/>
											) : (
												<PlusRoundIcon
													className="plusIcon"
													onClick={() => {
														setSelectedSubstitueGroup(
															d.substitueGroup
														);
													}}
												/>
											)}
											{d.substitueGroup}
										</div>
									</td>
									<td>{d.skuCount}</td>
									{selectedSubstitueGroup && (
										<>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
										</>
									)}
									<td>{numberFormatter(d.cost, 0, "$")}</td>
									{selectedSubstitueGroup && (
										<>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
										</>
									)}
									<td>
										{numberFormatter(
											d.adjMarginOpportunity,
											0,
											"$"
										)}
									</td>
									<td>
										<Button
											className={`savingButton`}
											onClick={() =>
												props.handleSaveButtonClick(d)
											}
										>
											Save
										</Button>
									</td>
								</tr>
								{selectedSubstitueGroup === d.substitueGroup &&
									d.materials?.map((m: any, i: any) => {
										return (
											<tr key={m.GBID + i}>
												<td></td>
												<td
													style={{
														textAlign: "start",
													}}
												>
													{m.itemDesc}
												</td>
												<td></td>
												<td>
													{removeLeadingZero(m.GBID)}
												</td>
												<td>
													{
														m.MANUFACTURER_PART_NO_MFRPN
													}
												</td>
												<td>{m.master_vendor_name}</td>
												<td>
													{numberWithCommas(m.volume)}
												</td>
												<td>
													{numberFormatter(
														m.cost,
														2,
														"$"
													)}
												</td>
												<td>
													{numberFormatter(
														m.Price,
														2,
														"$"
													)}
												</td>
												<td>
													{numberFormatter(
														m.Margin,
														2,
														"$"
													)}
												</td>
												<td
													style={{
														textAlign: "start",
													}}
												>
													<SelectPicker
														className="w-9/12 skuDropdown"
														onChange={(value) => {
															props.updateActionChange(
																m.GBID,
																value,
																index,
																i
															);
															props.getDefaultSubstituteSelection();
														}}
														searchable={false}
														data={actionOptions}
														// value={m.recommendation}
														defaultValue={
															m.recommendation
														}
														cleanable={false}
														placement="auto"
														container={() =>
															document.body
														}
													/>
												</td>
												<td
													style={{
														textAlign: "start",
													}}
												>
													{m.recommendation ===
														"Substitute" && (
														<SelectPicker
															className="w-9/12 skuDropdown"
															onChange={(
																value
															) => {
																props.updateSubstituteChange(
																	value,
																	index,
																	i
																);
																props.updateSelectedSubtitute(
																	value,
																	index,
																	i
																);
															}}
															searchable={false}
															data={getSubstituteOptions(
																d.materials
															)}
															value={
																m.selectedSubstitute
															}
															cleanable={false}
														/>
													)}
												</td>
												<td>
													{numberFormatter(
														m.adjMarginOpportunity,
														0,
														"$"
													)}
												</td>
												<td></td>
											</tr>
										);
									})}
							</React.Fragment>
						);
					})}
				</tbody>
			</table>
			<div className="pagination-components h-[15%]">
				{/* <div>
					<Button
						className="bg-transparent hover:bg-transparent"
						onClick={exportExcel}
					>
						<FileDownloadIcon
							color="black"
							className="text-fsre15"
						/>
					</Button>
					<CSVLink
						ref={exportFullRef}
						data={props.SKUExportData}
						headers={csvHeaders}
						filename="SKU.csv"
						className="hidden"
						target="_blank"
					>
						{" "}
					</CSVLink>
				</div> */}
				<Pagination
					prev
					next
					first
					last
					ellipsis
					boundaryLinks
					maxButtons={5}
					layout={["-", "pager", "skip"]}
					total={props.count}
					limit={20}
					activePage={props.pageNumber}
					onChangePage={(e) => {
						props.updatePageNumber(e);
					}}
				/>
			</div>
		</>
	);
};
export default SkuSubstitutionTable;
